import { RecordAccessLogsType } from '../../utils/type';
import { ApiMessage, ApiResponseHandler } from '../ApiResponseHandler';
import { THOM_BASE_URL } from '../Constant';
import ThomApiClient from '../ThomApiClient';

export const getAllRecordAccessLogs = async (): Promise<
  RecordAccessLogsType[]
> => {
  const clientId = localStorage.getItem('ClientId') ?? '';
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<RecordAccessLogsType[]>(
      `accessLogs?clientId=${clientId}`,
    ),
  );
};

export const createAndUpdateRecordAccessLogs = async (
  recordAccessLogs: RecordAccessLogsType,
): Promise<RecordAccessLogsType> => {
  const clientId = localStorage.getItem('ClientId') ?? '';
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(
      `accessLog?clientId=${clientId}`,
      recordAccessLogs,
    ),
  );
};

export const deleteRecordAccessLogs = async (
  id: string,
): Promise<ApiMessage> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(`accessLog/${id}`),
  );
};

export const downloadRecordAccessLog = async (): Promise<Blob> => {
  const clientId = localStorage.getItem('ClientId') ?? '';
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `accessLogs/download?clientId=${clientId}}`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};
